const state = {
  ativo: false
}

const getters = {
  ativo(state) {
    return state.ativo
  },
}

const mutations = {
  ativo(state, valor){
    state.ativo = valor
  },
}

const actions = {
  ativo: ({ commit }, valor) => {
    commit("ativo", valor)
  },
}

export default { namespaced: true, state, mutations, getters, actions }
